module.exports = __webpack_public_path__ + "img/Orangespine unicornfish.e053c7c7.png";